import React, { useState } from 'react'
import maybank from '../img/maybank.png';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import configData from "../appconfig/config.json";

export const Header = (props) => {

    const [showCloseAction, setshowCloseAction] = useState(false)

    const toCloseDialog = () => {

        setshowCloseAction(!showCloseAction);
    }
    const toNavigateHome = () => {

        document.location.href = configData.URL_NAVIGATE_COB;

    }
    const handleSubmit = () => {
        setshowCloseAction(!showCloseAction);
    }


    return (
        <div className='container-fluid header-background'>
            {showCloseAction && <Dialog onClose={toCloseDialog} title={"Please confirm"} >

                <p style={{ margin: "25px", textAlign: "center" }}> {configData.LBL_AREYOUSURE_EXIST}</p>
                <DialogActionsBar>
                    <button className="k-button k-primary" onClick={toCloseDialog}>No</button>
                    <button className="k-button k-secondary" onClick={toNavigateHome}>{configData.OK}</button>
                </DialogActionsBar>
            </Dialog>}

            <div className="d-flex border-bottom py-2">
                <div className="d-flex ">
                    <div className='project-name d-flex'  >
                        <span className="mx-0 my-auto logo">

                            <img className='imgHeader' src={maybank} alt='maybank' />

                        </span>
                    </div>

                </div>
                <div className='d-flex ml-auto nav'>
                    <button className="closeonheader" onClick={handleSubmit}>close  X</button>
                </div>
            </div>
        </div>




    )
}